import { TicketProduct } from '../client/src';

export const addFare = ({
  newFare,
  currentFares = [],
}: {
  newFare: TicketProduct;
  currentFares?: TicketProduct[];
}): TicketProduct[] => {
  const existingFareIndex = currentFares.findIndex(
    (fare) => fare.id === newFare.id
  );

  if (existingFareIndex < 0) {
    return [...currentFares, newFare];
  }

  return [
    ...currentFares.slice(0, existingFareIndex),
    newFare,
    ...currentFares.slice(existingFareIndex + 1),
  ];
};

export const addFares = ({
  newFares,
  currentFares = [],
}: {
  newFares: TicketProduct[];
  currentFares?: TicketProduct[];
}): TicketProduct[] => {
  return newFares.reduce(
    (agg: TicketProduct[], current: TicketProduct) => {
      const res = addFare({ newFare: current, currentFares: agg });
      res;
      return res;
    },
    [...currentFares]
  );
};
